import type { ReactNode } from 'react';

export function KV({ children }: { children: ReactNode }) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'auto 1fr',
        gap: '10px 24px',
        fontSize: 14,
        alignItems: 'baseline',
      }}
    >
      {children}
    </div>
  );
}

export function KVRow({ label, value }: { label: string; value: ReactNode }) {
  return (
    <>
      <div
        style={{
          fontWeight: 600,
          color: 'var(--muted)',
          whiteSpace: 'nowrap',
          fontSize: 13,
        }}
      >
        {label}
      </div>
      <div style={{ wordBreak: 'break-word' }}>{value}</div>
    </>
  );
}
